import React from 'react';
import { CHART_DATA, RESPONSE_TIME_DATA, FAILURE_BREAKDOWN } from '../../data/mockData';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, PieChart, Pie, Cell } from 'recharts';
import { Clock, AlertTriangle, TrendingDown, Zap } from 'lucide-react';
const tooltipStyle = {
  backgroundColor: '#1A1B1D',
  borderColor: '#2E3033',
  borderRadius: '8px',
  color: '#E8E8EC'
};
// Channel response time stats (averaged)
const channelStats = [{
  channel: 'USSD',
  avg: 1240,
  success: 96.2,
  color: '#2BE38C'
}, {
  channel: 'WhatsApp',
  avg: 2130,
  success: 94.1,
  color: '#1FB870'
}, {
  channel: 'SMS',
  avg: 3650,
  success: 88.4,
  color: '#1A7A4C'
}];
const FAILURE_COLORS = ['#EF4444', '#F59E0B', '#F97316', '#3B82F6', '#8B5CF6', '#6B7280'];
export function Reports() {
  const totalFailures = FAILURE_BREAKDOWN.reduce((s, f) => s + f.count, 0);
  const timeoutPct = FAILURE_BREAKDOWN.find(f => f.key === 'timeout')?.pct ?? 0;
  return <div className="max-w-6xl mx-auto space-y-6" data-id="element-726">
      <div className="flex items-center justify-between" data-id="element-727">
        <h1 className="text-2xl font-semibold text-bone" data-id="element-728">Reports</h1>
        <select className="bg-ink-3 border border-white/10 rounded-lg px-4 py-2 text-sm text-bone focus:outline-none focus:border-mint" data-id="element-729">
          <option data-id="element-730">This Month</option>
          <option data-id="element-731">Last Month</option>
          <option data-id="element-732">Last 3 Months</option>
        </select>
      </div>

      {/* Quick stat row */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-733">
        <div className="bg-ink-2 border border-white/5 rounded-2xl p-5" data-id="element-734">
          <div className="flex items-center justify-between mb-3" data-id="element-735">
            <div className="text-xs font-medium text-muted uppercase tracking-wider" data-id="element-736">
              Avg response
            </div>
            <Clock className="w-4 h-4 text-mint" data-id="element-737" />
          </div>
          <div className="text-2xl font-semibold text-bone" data-id="element-738">1.84s</div>
          <div className="text-xs text-mint mt-1" data-id="element-739">-12% vs last week</div>
        </div>
        <div className="bg-ink-2 border border-white/5 rounded-2xl p-5" data-id="element-740">
          <div className="flex items-center justify-between mb-3" data-id="element-741">
            <div className="text-xs font-medium text-muted uppercase tracking-wider" data-id="element-742">
              P95 response
            </div>
            <Zap className="w-4 h-4 text-mint" data-id="element-743" />
          </div>
          <div className="text-2xl font-semibold text-bone" data-id="element-744">4.2s</div>
          <div className="text-xs text-muted mt-1" data-id="element-745">USSD: 2.1s · WA: 4.8s</div>
        </div>
        <div className="bg-ink-2 border border-white/5 rounded-2xl p-5" data-id="element-746">
          <div className="flex items-center justify-between mb-3" data-id="element-747">
            <div className="text-xs font-medium text-muted uppercase tracking-wider" data-id="element-748">
              Total failures
            </div>
            <AlertTriangle className="w-4 h-4 text-red-400" data-id="element-749" />
          </div>
          <div className="text-2xl font-semibold text-bone" data-id="element-750">
            {totalFailures}
          </div>
          <div className="text-xs text-muted mt-1" data-id="element-751">2.4% of all volume</div>
        </div>
        <div className="bg-ink-2 border border-white/5 rounded-2xl p-5" data-id="element-752">
          <div className="flex items-center justify-between mb-3" data-id="element-753">
            <div className="text-xs font-medium text-muted uppercase tracking-wider" data-id="element-754">
              Timeouts
            </div>
            <TrendingDown className="w-4 h-4 text-red-400" data-id="element-755" />
          </div>
          <div className="text-2xl font-semibold text-red-400" data-id="element-756">
            {timeoutPct}%
          </div>
          <div className="text-xs text-muted mt-1" data-id="element-757">
            of failures · top reason
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-758">
        {/* Channel mix */}
        <div className="bg-ink-2 border border-white/5 rounded-2xl p-6" data-id="element-759">
          <h2 className="text-lg font-semibold text-bone mb-1" data-id="element-760">
            Collection by channel
          </h2>
          <p className="text-xs text-muted mb-6" data-id="element-761">
            Weekly volume in ZAR, stacked by channel
          </p>
          <div className="h-[280px] w-full" data-id="element-762">
            <ResponsiveContainer width="100%" height="100%" data-id="element-763">
              <BarChart data={CHART_DATA} margin={{
              top: 10,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-764">
                
                <CartesianGrid strokeDasharray="3 3" stroke="#2E3033" vertical={false} data-id="element-765" />
                
                <XAxis dataKey="name" stroke="#8A8B8F" fontSize={12} tickLine={false} axisLine={false} data-id="element-766" />
                
                <YAxis stroke="#8A8B8F" fontSize={12} tickLine={false} axisLine={false} tickFormatter={v => `R${v / 1000}k`} data-id="element-767" />
                
                <Tooltip contentStyle={tooltipStyle} cursor={{
                fill: '#2E3033',
                opacity: 0.4
              }} data-id="element-768" />
                
                <Legend wrapperStyle={{
                fontSize: '12px',
                color: '#8A8B8F'
              }} data-id="element-769" />
                
                <Bar dataKey="ussd" name="USSD" stackId="a" fill="#2BE38C" radius={[0, 0, 4, 4]} data-id="element-770" />
                
                <Bar dataKey="whatsapp" name="WhatsApp" stackId="a" fill="#1FB870" data-id="element-771" />
                
                <Bar dataKey="sms" name="SMS" stackId="a" fill="#1A7A4C" radius={[4, 4, 0, 0]} data-id="element-772" />
                
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Response time by channel */}
        <div className="bg-ink-2 border border-white/5 rounded-2xl p-6" data-id="element-773">
          <h2 className="text-lg font-semibold text-bone mb-1" data-id="element-774">
            Response time by channel
          </h2>
          <p className="text-xs text-muted mb-6" data-id="element-775">
            Average milliseconds to confirmation, last 7 days
          </p>
          <div className="h-[280px] w-full" data-id="element-776">
            <ResponsiveContainer width="100%" height="100%" data-id="element-777">
              <LineChart data={RESPONSE_TIME_DATA} margin={{
              top: 10,
              right: 10,
              left: -10,
              bottom: 0
            }} data-id="element-778">
                
                <CartesianGrid strokeDasharray="3 3" stroke="#2E3033" vertical={false} data-id="element-779" />
                
                <XAxis dataKey="name" stroke="#8A8B8F" fontSize={12} tickLine={false} axisLine={false} data-id="element-780" />
                
                <YAxis stroke="#8A8B8F" fontSize={12} tickLine={false} axisLine={false} tickFormatter={v => `${(v / 1000).toFixed(1)}s`} data-id="element-781" />
                
                <Tooltip contentStyle={tooltipStyle} formatter={(v: number) => `${(v / 1000).toFixed(2)} s`} data-id="element-782" />
                
                <Legend wrapperStyle={{
                fontSize: '12px',
                color: '#8A8B8F'
              }} data-id="element-783" />
                
                <Line type="monotone" dataKey="USSD" stroke="#2BE38C" strokeWidth={2} dot={false} data-id="element-784" />
                
                <Line type="monotone" dataKey="WhatsApp" stroke="#3B82F6" strokeWidth={2} dot={false} data-id="element-785" />
                
                <Line type="monotone" dataKey="SMS" stroke="#F59E0B" strokeWidth={2} dot={false} data-id="element-786" />
                
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-787">
        {/* Failure breakdown */}
        <div className="bg-ink-2 border border-white/5 rounded-2xl p-6" data-id="element-788">
          <h2 className="text-lg font-semibold text-bone mb-1" data-id="element-789">
            Failure reasons
          </h2>
          <p className="text-xs text-muted mb-6" data-id="element-790">
            Breakdown of {totalFailures} failed transactions
          </p>
          <div className="grid grid-cols-[1fr,1fr] gap-4 items-center" data-id="element-791">
            <div className="h-[200px]" data-id="element-792">
              <ResponsiveContainer width="100%" height="100%" data-id="element-793">
                <PieChart data-id="element-794">
                  <Pie data={FAILURE_BREAKDOWN} dataKey="count" nameKey="reason" innerRadius={50} outerRadius={80} paddingAngle={2} data-id="element-795">
                    
                    {FAILURE_BREAKDOWN.map((_, i) => <Cell key={i} fill={FAILURE_COLORS[i]} stroke="#0E0F10" strokeWidth={2} data-id="element-796" />)}
                  </Pie>
                  <Tooltip contentStyle={tooltipStyle} formatter={(v: number) => `${v} failures`} data-id="element-797" />
                  
                </PieChart>
              </ResponsiveContainer>
            </div>
            <div className="space-y-2" data-id="element-798">
              {FAILURE_BREAKDOWN.map((f, i) => <div key={f.key} className="flex items-center justify-between text-xs" data-id="element-799">
                
                  <div className="flex items-center gap-2 min-w-0" data-id="element-800">
                    <span className="w-2.5 h-2.5 rounded-sm flex-shrink-0" style={{
                  backgroundColor: FAILURE_COLORS[i]
                }} data-id="element-801">
                  </span>
                    <span className="text-bone-dim truncate" data-id="element-802">{f.reason}</span>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0" data-id="element-803">
                    <span className="text-bone font-medium mono" data-id="element-804">
                      {f.count}
                    </span>
                    <span className="text-muted w-8 text-right" data-id="element-805">{f.pct}%</span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Per-channel performance */}
        <div className="bg-ink-2 border border-white/5 rounded-2xl p-6" data-id="element-806">
          <h2 className="text-lg font-semibold text-bone mb-1" data-id="element-807">
            Channel performance
          </h2>
          <p className="text-xs text-muted mb-6" data-id="element-808">
            Avg response time and success rate
          </p>
          <div className="space-y-4" data-id="element-809">
            {channelStats.map(c => <div key={c.channel} className="bg-ink rounded-xl p-4 border border-white/5" data-id="element-810">
              
                <div className="flex items-center justify-between mb-3" data-id="element-811">
                  <div className="flex items-center gap-2" data-id="element-812">
                    <span className="w-2 h-2 rounded-full" style={{
                  backgroundColor: c.color
                }} data-id="element-813">
                  </span>
                    <span className="font-medium text-bone" data-id="element-814">{c.channel}</span>
                  </div>
                  <span className={`text-xs font-medium ${c.success > 95 ? 'text-mint' : c.success > 90 ? 'text-yellow-500' : 'text-red-400'}`} data-id="element-815">
                  
                    {c.success}% success
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-816">
                  <div data-id="element-817">
                    <div className="text-[10px] text-muted uppercase tracking-wider mb-1" data-id="element-818">
                      Avg response
                    </div>
                    <div className="text-lg font-semibold text-bone" data-id="element-819">
                      {(c.avg / 1000).toFixed(2)}s
                    </div>
                  </div>
                  <div data-id="element-820">
                    <div className="text-[10px] text-muted uppercase tracking-wider mb-1" data-id="element-821">
                      P95
                    </div>
                    <div className="text-lg font-semibold text-bone" data-id="element-822">
                      {(c.avg * 2.1 / 1000).toFixed(1)}s
                    </div>
                  </div>
                </div>
                {/* progress bar */}
                <div className="mt-3 h-1 bg-ink-3 rounded-full overflow-hidden" data-id="element-823">
                  <div className="h-full rounded-full" style={{
                width: `${c.success}%`,
                backgroundColor: c.color
              }} data-id="element-824">
                </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}